module.exports = __webpack_public_path__ + "img/time_20.c0b39a54.svg";